import React from 'react'

import { useQuery, useMutation } from '@apollo/react-hooks'
import { Query, Mutation } from '../../../api'

import * as yup from 'yup'
import { toastr } from 'react-redux-toastr'
import { Formik, Form } from 'formik'
import { Button } from '@/components/ui/button'
import { Save } from 'lucide-react'
import Loading from '../../../components/Loading'
import Input from '../../../components/form/FormikInput'
import AddressForm from '../../../components/form/Address'
import { useTranslation } from 'react-i18next'
import { useUser } from '../../../hooks'

const initialValues = {
  name: '',
  description: '',
  address: { ...AddressForm.initialValues },
}

const OrganizationInfo = () => {
  const { t } = useTranslation()
  const me = useUser()
  const canEdit = me?.rights === 'OWNER'
  const { data, loading } = useQuery(Query.ORGANIZATION)
  const [updateOrg, updateOrgData] = useMutation(Mutation.UPDATE_ORGANIZATION, {
    onCompleted: () => {
      toastr.success(t('Organization_info_organization_info_has_been_updated_label'))
    },
  })

  const isLoading = loading || updateOrgData.loading
  const organization = data ? data.organization : {}

  const schema = yup.object().shape({
    name: yup
      .string()
      .min(3, t('Organization_info_name_min'))
      .required(t('Organization_info_name_required')),
    description: yup
      .string()
      .required(t('Organization_info_description_required'))
      .nullable(),
    address: AddressForm.validationSchemaOptional,
  })

  return (
    <Formik
      validationSchema={schema}
      initialValues={{
        ...initialValues,
        ...organization,
      }}
      enableReinitialize
      onSubmit={(values) => {
        updateOrg({ variables: { ...values } })
      }}
    >
      {() => (
        <Form className="relative">
          {!canEdit && (
            <p className="mb-4 text-sm text-muted-foreground">
              {t('Organization_info_read_only_hint')}
            </p>
          )}
          <fieldset disabled={!canEdit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <Input
                type="text"
                name="name"
                label={t('Organization_info_name_label')}
                placeholder={t('Organization_info_name_placeholder')}
              />
              <Input
                type="textarea"
                rows={5}
                name="description"
                label={t('Organization_info_description_label')}
                placeholder={t('Organization_info_description_placeholder')}
              />
            </div>
            <div>
              <AddressForm name="address" />
            </div>
          </fieldset>
          {canEdit && (
            <div className="mt-6">
              <Button type="submit">
                <Save className="h-4 w-4" />
                {t('Organization_info_save_changes_btn')}
              </Button>
            </div>
          )}
          {isLoading && <Loading />}
        </Form>
      )}
    </Formik>
  )
}

export default OrganizationInfo
